import { render, staticRenderFns } from "./InvestmentsSettings.vue?vue&type=template&id=7720172b&scoped=true&"
import script from "./InvestmentsSettings.vue?vue&type=script&lang=js&"
export * from "./InvestmentsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7720172b",
  null
  
)

export default component.exports